// Annoucement Bar JS 


// End For Annoucement Bar JS 

// Home page navigation JS web 

$('.main-level-data1').click(function(){
  $('.main-search-header').hide();
  if($(this).closest('li').find('.main-level-data2').hasClass('show')){
    $(this).closest('li').find('.main-level-data2').removeClass('show');
  }else{
    $('.main-level-data2').removeClass('show');
    $('.main-level-data4 ').hide();
    $(this).closest('li').find('.main-level-data2').addClass('show');
  }
})

$('.main-level-data3').click(function(){
  $('.main-level-data4 ').hide();
  $(this).closest('li').find('ul').toggle();
})

$('.main-level-data3').click(function(){
  var a =  $(this).closest('li').find('ul').height();
  var b = a + 20;
  $(this).closest('ul').css('min-height',b);
})


$(window).scroll(function(){
  var scroll = $(window).scrollTop();
  if(scroll > 50){
    $('.main-search-header').hide();
    $('.main-level-data2').removeClass('show');
    $('.main-level-data4 ').hide();
    $('.sort-btn').removeClass('open-v');
    $('.sort-btn').removeClass('open-v');
    $('.filter-toggle__btn_left').removeClass('open-v');
    $('.dropdown-sort').removeClass('active');
    $('.dropdown-sort').removeClass('active');
    $('.filter-menu').removeClass('active');
  }
})


// Web Layout Search Open

$('.search-btn').click(function(){
  $('.cartNav').removeClass('cart-open');
  $('.main-level-data2').hide();
  $('.main-search-header').toggle();
})


// Hamburger Nav JS 

var hamburger = document.getElementById("nav-icon");
hamburger.addEventListener("click", function(){
  document.querySelector(".side-nav-list").classList.toggle("slide-in");
  document.querySelector(".announcement-main").classList.toggle("navbar-open");
  document.querySelector(".hamburger").classList.toggle("close");
  document.querySelector(".header-wrap-mobile").classList.toggle("humberger-menu-open");
});



$('#nav-icon').click(function(){
	$(this).toggleClass('close');
})



$('.country-drop-mobile-main').click(function(){
	$('.country-drop-mobile').toggleClass('open-country-drop-mobile');
})

//  Infinite Scroll JS for the Category Page

if($('body').hasClass('collection')){
  document.addEventListener("DOMContentLoaded", function() {
    var endlessScroll = new Ajaxinate({
      container: '#Huratips-Loop',
      pagination: '#Huratips-Pagination'
    });
  });
}


// Main Home page Slider JS 

$('.main-slider-homepage').slick({
  dots: true,
  infinite: false,
  arrows: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

// Cart Drwert Open




//  Fixed Header JQuery 

// if ($('body').hasClass('inner-page')){
//   var lastScroll = 0;
//   $(window).scroll(function(){
//     setTimeout(function() { //give them a second to finish scrolling before doing a check
//       var scroll = $(window).scrollTop();
//       if (scroll > lastScroll + 30) {
//         $("header").removeClass("pos-fixed");
//         $("header").addClass("pos-added");
//       } else if (scroll < lastScroll - 30) {
//         $("header").addClass("pos-fixed");
//         $("header").removeClass("pos-added");
//       }
//       lastScroll = scroll;
//     }, 1000);
//   });
// }

// 

$(".hero-wrap").slick({
  infinite: true,
  fade: true,
  speed: 300,
  autoplay: true,
  dots: true,
  arrows: false,
  nextArrow: '<small class="slick-next">&rarr;</small>',
  prevArrow: '<small class="slick-prev">&larr;</small>',
  customPaging : function(slider, i) {
    var thumb = $(slider.$slides[i]).data();
    // return '<a>'+(i+1)+'</a>';
    return '<a>&bull;</a>';
  },
});




$('.filter-toggle__btn_left').click(function(){
  $(".dropdown-sort").removeClass('active');
  $('.sort-btn').removeClass("open-v");
  if($('#filter-toggle-menu_left').hasClass('active')){
    $('#filter-toggle-menu_left').removeClass('active');
    $('body').removeClass('filter-open-on-mobile');
    $(this).removeClass("open-v");
  }else{
    $('#filter-toggle-menu_left').addClass('active');
    $('body').addClass('filter-open-on-mobile');
    $(this).addClass("open-v");
  }
})

$(".sort-btn").click(function(){
  $("#filter-toggle-menu_left").removeClass('active');
  $(".filter-toggle__btn_left").removeClass("open-v");
  if($('.dropdown-sort').hasClass('active')){
    $('.dropdown-sort').removeClass('active');
    $(this).removeClass("open-v");
    $('body').removeClass('filter-open-on-mobile');
  }else{
    $('.dropdown-sort').addClass('active');
    $(this).addClass("open-v");
    $('body').addClass('filter-open-on-mobile');
  }
});

$(document).ready(function($) {

  $('.sortByCheckBox').on('change', function() {
    if($(this).is(':checked'))
    {
      var uri = window.location.href.toString();
      if (uri.indexOf("?") > 0) {
        var clean_uri = uri.substring(0, uri.indexOf("?"));

        var val = $(this).val();
        window.location.href = clean_uri + '?sort_by='+val;
      }else{

        var uri = window.location.href.toString();
        var val = $(this).val();
        var urii = uri +'?sort_by='+val
        window.location.href = urii;
      }  
    }else
    {
      var uri = window.location.href.toString();
      if (uri.indexOf("?") > 0) {
        var clean_uri = uri.substring(0, uri.indexOf("?"));
        window.location.href = clean_uri
      }else{

        var uri = window.location.href.toString();
        window.location.href = uri;
      }
    }
    $('.sortByCheckBox').not(this).prop('checked', false);  
  });

  var queries = {};
  $.each(document.location.search.substr(1).split('&'),function(c,q){
    var i = q.split('=');
    if(i != ''){
      queries[i[0].toString()] = i[1].toString();
    }
  });

  var a = queries.sort_by;

  $('.sortByCheckBox').each(function(){
    if($(this).val() == a){
      $(this).prop('checked', true);  
    }
  })

  
  
  var dataURL = window.location.href,
      newURL = dataURL.substr(dataURL.indexOf("com") + 4);
      $(".country-us").prop("href", "https://www.bodaskins.us.com/" + newURL);
      $(".country-row").prop("href", "https://www.bodaskins.com/" + newURL);
      $(".country-eu").prop("href", "https://www.bodaskins.eu.com/" + newURL);
      $(".country-aus").prop("href", "https://bodaskinsau.com/" + newURL);
  
  
  
  
  
});

$('.one-time').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  arrows:false,
  autoplay: true,
  autoplaySpeed: 10000
});



$('#nav-reviews-tab').click(function(){
  $('.okeReviews-widget-holder').addClass('widget-show');
})

$('#nav-wishlist-tab,#nav-share-tab,#nav-contact-tab,#nav-spreadthecost-tab,#nav-shipping-tab,#nav-returns-tab').click(function(){
  $('.okeReviews-widget-holder').removeClass('widget-show');
})




$('[data-title="Engraving"]').click(function(){
  if($(this).is(":checked")) {
    $('.custom-input-extra').addClass("show");
  } else {
    $('.custom-input-extra').removeClass("show");
  }
});
$('[data-title="Engraving"]').click(function(){
  if($(this).is(":checked")) {
    $('.custom-input-extra2').addClass("show");
  } else {
    $('.custom-input-extra2').removeClass("show");
  }
});


$('#prop_name').on('keyup', function () {
  var oldtext = $('#prop_name').val();
  if(oldtext.length <= 9) {
    $('#prop_name').val('MADE FOR ');
  }
  var newtext = oldtext;
  substring = "MADE FOR";
  if(oldtext.includes(substring)) {
  } else {
    newtext = 'MADE FOR '+oldtext;
  }

  var a = this.value.length;
  var b = 33 - a;
  $('.character-counter').text(b);
});

$('#prop_name2').on('keyup', function () {
  var oldtext = $('#prop_name2').val();
  if(oldtext.length <= 10) {
    $('#prop_name2').val();
  }
  var newtext = oldtext;
  // substring = "DOG NAME";
  if(oldtext.includes()) {
  } else {
    newtext = oldtext;
  }

  var a = this.value.length;
  var b = 24 - a;
  $('.character-counter2').text(b);
});

$('#prop_name3').on('keyup', function () {
  var oldtext = $('#prop_name3').val();
  if(oldtext.length <= 10) {
    $('#prop_name3').val();
  }
  var newtext = oldtext;
  // substring = "PHONE NUMBER";
  if(oldtext.includes()) {
  } else {
    newtext = oldtext;
  }

  var a = this.value.length;
  var b = 24 - a;
  $('.character-counter3').text(b);
});

$(window).scroll(function() {    
  var scroll = $(window).scrollTop();

  //>=, not <=
  if (scroll >= 50) {
    //clearHeader, not clearheader - caps H
    $(".header-wrap,.header-wrap-mobile").addClass("header-top-0");
    $('.announcement-main').addClass("active-bar");
  }else{
    $(".header-wrap,.header-wrap-mobile").removeClass("header-top-0");
    $('.announcement-main').removeClass("active-bar");
  }
}); //missing );.


// Size Guide accordion

$(".size-guide-popup .accordion_head").click(function(){
  if ($('.size-guide-popup .accordion_body').is(':visible')) {
    $(".size-guide-popup .accordion_body").slideUp(300);
    $(".size-guide-popup .plusminus").text('+');
  }
  if ($(this).next(".accordion_body").is(':visible')) {
    $(this).next(".accordion_body").slideUp(300);
    $(this).children(".plusminus").text('+');
  } else {
    $(this).next(".accordion_body").slideDown(300);
    $(this).children(".plusminus").text('-');
  }
})

$('#custom-tailoring-button').click(function(){
   var iframeWindow = document.getElementById('chat-button').contentWindow;
    var iframeDocument = iframeWindow.document;
    var buttonElement = iframeDocument.getElementById('gorgias-chat-messenger-button');
    $(buttonElement).trigger('click');
})


// custom filter
 
  var urlParams = new URLSearchParams(window.location.search);
  var genderParam = urlParams.get('gender');

  var productGridContainer = document.getElementById('ProductGridContainer');
  if (genderParam === 'man') {
    productGridContainer.classList.add('man-filter');
  } else if (genderParam === 'woman') {
    productGridContainer.classList.add('woman-filter');
  }

  function setSelectedSize() {
    var selectedSize = localStorage.getItem('selectedSize');
    var selectedGender = localStorage.getItem('selectedGender');
    if (selectedSize && selectedGender) {
      document.querySelectorAll('.size-link').forEach(function(link) {
        if (link.getAttribute('data-size') === selectedSize && link.getAttribute('data-gender') === selectedGender) {
          link.classList.add('selected');
        }
      });
    }
  }
  document.querySelectorAll('.size-link').forEach(function(link) {
    link.addEventListener('click', function(event) {     
      localStorage.setItem('selectedSize', this.getAttribute('data-size'));
      localStorage.setItem('selectedGender', this.getAttribute('data-gender'));    
      document.querySelectorAll('.size-link').forEach(function(link) {
        link.classList.remove('selected');
      });   
      this.classList.add('selected');
    });
  });
  document.addEventListener('DOMContentLoaded', setSelectedSize);


// read more read less description
  document.addEventListener("DOMContentLoaded", function () {
    const descContainer = document.getElementById("collection-description");
    const toggleBtn = document.getElementById("toggle-description");

    if (descContainer && toggleBtn) {
      const fullText = descContainer.getAttribute("data-full-text");
      const wordLimit = 20;
      const words = fullText.split(" ");

      if (words.length > wordLimit) {
        const shortText = words.slice(0, wordLimit).join(" ") + "...";
        descContainer.innerHTML = shortText;
        toggleBtn.style.display = "inline-block";
        let isExpanded = false;

        toggleBtn.addEventListener("click", function () {
          // Add fade out effect
          descContainer.classList.add("fade-out");
          descContainer.classList.remove("fade-in");

          // Wait for fade out to complete, then change content and fade in
          setTimeout(function() {
            if (isExpanded) {
              descContainer.innerHTML = shortText;
              toggleBtn.textContent = "Read more";
            } else {
              descContainer.innerHTML = fullText;
              toggleBtn.textContent = "Read less";
            }

            // Add fade in effect
            descContainer.classList.remove("fade-out");
            descContainer.classList.add("fade-in");

            isExpanded = !isExpanded;
          }, 300); // Match the CSS transition duration
        });
      }
    }
  });